import type { TimeInterval } from "../types/chart-types";

export const CHART_CONFIG = {
  padding: {
    yAxisPercentage: 0.01,
    minRangePercentage: 0.05,
    emptySpaceFraction: 0.25,
  },
  zoom: {
    default: 40,
    min: 15,
    proportionalStep: 0.2,
    minStep: 5,
    wheelPixelsPerStep: 100,
    trackpadSpeedMultiplier: 1.2,
  },
  animation: {
    shiftDuration: 1500,
    interpolationDuration: 900,
    liveCandleDuration: 360,
  },
  scroll: {
    viewportThreshold: 1.0,
    inactivityTimeout: 5000,
  },
} as const;

const MAX_ZOOM_BY_INTERVAL: Record<TimeInterval, number> = {
  "5S": 60,
  "15S": 60,
  "30S": 60,
  "1M": 2000,
  "2M": 90,
  "3M": 90,
  "5M": 90,
  "10M": 90,
  "15M": 120,
  "30M": 120,
  "1H": 150,
  "4H": 150,
  "1D": 2000,
};

export function getMaxZoom(interval: TimeInterval): number {
  return MAX_ZOOM_BY_INTERVAL[interval];
}
